import { createEvent, createStore, merge } from 'effector';
import { createGate } from 'effector-react';
import { pending } from 'patronum';
import { fxClearEndedCalls, fxGetContactCalls } from '../calls/model';
import { PopperVisiblity } from './types';

export const ContactCallsGate = createGate();

export const $isPopperVisible = createStore<PopperVisiblity>(false);
export const setPopperVisiblity = createEvent<PopperVisiblity>();

export const $isLoading = pending({
  effects: [fxGetContactCalls, fxClearEndedCalls],
});

export const $error = createStore<Error | null>(null);
export const clearError = createEvent();
export const errorOccured = merge([fxGetContactCalls.fail, fxClearEndedCalls.fail]);
